<template>
    <BaseElement v-model="value" :edit="edit" :create="create" :element="'input'">
        <template main>
            <template v-if="edit">
                <VueMultiselect
                    :options="options"
                    :placeholder="value.placeholder"
                    :id="value.id"
                    :class="value.class"
                    :style="value.style"
                    :disabled="value.disabled"
                    :type="value.type"
                    v-model="value.value"
                    label="text"
                    track-by="id"
                    class="w-100"
                    :select-label="$t('multiselect.pressToSelect')"
                    :selected-label="$t('multiselect.selected')"
                    :multiple="value.multiple"
                    :deselect-label="$t('multiselect.pressToDeselect')"
                    :showNoResults="false">
                </VueMultiselect>
            </template>
            <template v-else>
                <p
                    :id="value.id"
                    :class="value.class"
                    :style="value.style"
                    :disabled="value.disabled"
                    :type="value.type"
                >

                    <span>{{ text }}</span>
                </p>
            </template>
        </template>
    </BaseElement>
</template>

<script>
import BaseElement from '@/components/calculations/BaseElement.vue';
import VueMultiselect from 'vue-multiselect';

export default {
    components: {
        BaseElement,
        VueMultiselect
    },
    props: {
        modelValue: {},
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            output: []
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        show: function () {
            return this.value && !this.value.hide;
        },
        options: function () {
            if (!this.value || !this.value.options) {
                return []
            }
            var data = []
            var lines = this.value.options.split("\n");
            for (var i = 0; i < lines.length; i++){
                data.push({
                    id: i,
                    text: lines[i]
                });
            }
            return data;
        }
    }
}
</script>

<style lang="scss">
</style>